module.exports = __webpack_public_path__ + "static/img/bg5.cefabd00.png";